export const environment = {
  apiBasePath: '/api',
  defaultLang: 'en',
  production: false,
  focoosProdApiUrl: '/focoos/v0',
  focoosModel: '0a963f16205c4077',
  s3BaseUrl: '/assets/s3',
};
